<template>
    <div class="menu-container">
        <nav id="navbar" class="nav-bar" v-bind:class="[{'active': activated}, {'nav-bar--light': sectionThemeDark}, {'nav-bar--dark': !sectionThemeDark}]">
            <a @click.prevent="goBack">
                <div class="menu icon icon-back-button"></div> 
            </a>
        </nav>
        <div id="socialIconsWeb" class="social-icons-web">
            <ul class="social-items" v-bind:class="[{'light': socialIconsWebThemeDark}, {'dark': !socialIconsWebThemeDark}]">
                <li><a href="https://www.facebook.com/GlobalChoicesZA/" class="facebook" target="_blank" rel="noopener noreferrer"></a></li>
                <li><a href="https://twitter.com/GlobalChoicesZA" class="twitter" target="_blank" rel="noopener noreferrer"></a></li>
                <li><a href="https://www.linkedin.com/company/global-choices-lifestyle/?originalSubdomain=za" class="linkedin" target="_blank" rel="noopener noreferrer"></a></li>
                <li><a href="https://www.instagram.com/globalchoicesza/" class="instagram" target="_blank" rel="noopener noreferrer"></a></li>
                <li><a href="https://www.youtube.com/channel/UCbCW_LVHs3zhXqtY6yRETBQ" class="youtube" target="_blank" rel="noopener noreferrer"></a></li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "ReturnMenu",
    data() {
        return {
            activated: false,
            sectionThemeDark: true,
            socialIconsWebThemeDark: true,
            previousScrollPosition: 0
        };
    },
    methods: {
        goBack() {
            window.history.back();  // Navigate to the previous page in the browser history
        },
        handleNavigation(to, from) {
            if (from) {
                this.previousScrollPosition = window.scrollY;  // Save the scroll position before navigating away
            }
            if (!to.meta.keepScroll) {
                window.scrollTo(0, 0);  // Reset scroll to the top when navigating to a new page
            } else {
                window.scrollTo(0, this.previousScrollPosition);  // Scroll back to the previous position when going back
            }
        }
    },
    watch: {
        "$route"(to, from) {
            this.handleNavigation(to, from);  // Handle route change and scroll behavior
        }
    }
};
</script>

<style lang="scss" scoped>
.appTheme {
    background-color: #575756;
    a {
        color: #ffffff;
    }
}
.companyTheme {
    background-color: #ffffff;
    a {
        color: #575756;
    }
}
</style>
